import {
  ButtonSize,
  ButtonType,
  CSSProperties,
  ControlType,
  Image,
  TabItem,
  ValueType
} from '@com-delta-idp/mnx-ui-kit';
import {
  CreditSummary,
  CreditSummaryStyles
} from './credit-summary.interfaces';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export interface OfferBannerState {
  offer: OfferBanner;
  offerStyles: OfferBannerStyles;
  offerConfig: OfferBannerConfig;
}

// **** UI Kit interfaces **** //
export interface OfferBanner {
  action?: CallToAction;
  annualFee?: string;
  benefit?: string;
  cardType?: string;
  details?: string;
  headline?: string;
  image?: Image;
  links?: TabItem[];
  offer: string;
  pageId?: string;
  summary?: CreditSummary;
}

/** Configuration interface for hide or show banner sections */
export interface OfferBannerConfig {
  congratulation?: boolean;
  showAction?: boolean;
  showBenefit?: boolean;
  showCreditSummary?: boolean;
  showDetails?: boolean;
  showHeadline?: boolean;
  showLinks?: boolean;
  showOffer?: boolean;
  enrollmentTheme?: boolean;
  enabled?: boolean;
}

export interface ValidDisplay {
  display: boolean;
  type: 'award' | 'revenue';
}

export interface OfferBannerStyles {
  creditSummary: CreditSummaryStyles;
  offer: OfferStyles;
  welcome: WelcomeStyles;
}

// **** Section styles interfaces **** //
export type Orientation = 'horizontal' | 'vertical';
export interface OfferStyles {
  annualFee?: CSSProperties;
  benefit?: CSSProperties;
  bullets?: CSSProperties;
  buttonLabel?: CSSProperties;
  checkLabel?: CSSProperties;
  checkSectionBackgroundColor?: string;
  /** This will hold style only for offer banner container */
  containerStyles?: CSSProperties;
  details?: CSSProperties;
  heading1?: CSSProperties;
  heading2?: CSSProperties;
  image?: CSSProperties;
  links?: CSSProperties;
  actionOrientation?: Orientation;
  actionSize?: ButtonSize;
  actionType?: ButtonType;
}

export interface WelcomeStyles {
  congratsSection: CSSProperties;
  image?: CSSProperties;
  welcomeBanner: CSSProperties;
  welcomeSection: CSSProperties;
}

export interface Currency {
  code?: string;
  symbol?: string;
}

export interface Pricing {
  cash?: Price;
  miles?: Price;
  multiUnit?: boolean;
}

export interface Price extends Currency {
  fraction?: string | number;
  decimal?: string | number;
  type?: ValueType;
  value?: string | number;
}

export interface Link {
  label: string;
  url: string;
}

export interface CallToAction {
  input: ControlType;
  link: Link;
  linkId?: string;
  message?: GenericLabel;
  secondaryLink?: Link;
  secondaryLinkId?: string;
  enable?: boolean;
}
